// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&family=Roboto:wght@400;700&family=Lato:wght@400;700&family=Montserrat:wght@400;700&family=Poppins:wght@400;700&family=Raleway:wght@400;700&family=Source+Sans+Pro:wght@400;700&family=Ubuntu:wght@400;700&family=Nunito:wght@400;700&family=Playfair+Display:wght@400;700&family=Merriweather:wght@400;700&family=Inter:wght@400;700&family=Noto+Sans:wght@400;700&family=Quicksand:wght@400;700&family=Work+Sans:wght@400;700&family=Rubik:wght@400;700&family=Mulish:wght@400;700&family=DM+Sans:wght@400;700&family=Outfit:wght@400;700&family=Josefin+Sans:wght@400;700&family=Crimson+Text:wght@400;700&family=Space+Grotesk:wght@400;700&family=Manrope:wght@400;700&family=Fira+Sans:wght@400;700&family=Karla:wght@400;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* General */
  --qa-backgroundColor: #ffffff;

  /* Question */
  --qa-questionBackgroundColor: #F7F8FE;
  --qa-questionBorderColor: #dbe0f7;
  --qa-questionTextColor: #000000;
  --qa-questionIconColor: #3D97FC;
  --qa-questionGlowColor: #3D97FC;

  /* Focus Section */
  --qa-focusSectionBorderColor: #bdcde4;
  --qa-focusSectionSeperatorBorderColor: #ececec;

  --qa-focusSectionQuestionFontSize: 16px;
  --qa-focusSectionQuestionFontWeight: 600; /* NEW */
  --qa-focusSectionQuestionBackgroundColor: #ffffff;
  --qa-focusSectionQuestionTextColor: #000000;
  
  --qa-focusSectionAnswerFontSize: 14px;
  --qa-focusSectionAnswerBackgroundColor: #ffffff;
  --qa-focusSectionAnswerTextColor: #000000;

  /* FeedbackThumbs */
  --qa-thumbsColor: #3D97FC;

  /* Navbar */
  --qa-navbarBackgroundColor: #F7F8FE;

  --qa-navbarActiveBackgroundColor: #ffffff;
  --qa-navbarActiveTextColor: #000000;

  --qa-navbarTextColor: #a2a2a2;

  --qa-navbarHoverBackgroundColor: #ffffff;
  --qa-navbarHoverTextColor: #000000;

  --qa-navbarKeyWordButtonMobileBorderColor: #818181;

  --qa-navbarKeyWordButtonMobileActiveBackgroundColor: #545454;


  /* Chatfield */
  --qa-chatfieldBackgroundColor: #f9f9f9;
  --qa-chatfieldBorderColor: #e1e1e1;
  
  --qa-chatfieldTextColor: #000000;
  --qa-chatfieldIconColor: #3D97FC;

  --qa-chatfieldPlaceholderColor: #96a4b3;


  /* Extra */
  --qa-disclaimerPopupBackgroundColor: #F7F8FE;
  --qa-disclaimerPopupTextColor: #000000;

  --qa-feedbackPopupBackgroundColor: #ffffff;
  --qa-feedbackPopupTextColor: #000000;


  /* Font */
  --qa-fontFamily: inherit;

  --qa-questionFontSize: 12px;
  --qa-focusSectionQuestionFontSize: 16px;
  --qa-chatFieldFontSize: 14px;
  --qa-navKeywordButtonFontSize: 10px;
}
`, "",{"version":3,"sources":["webpack://./app/globals.css"],"names":[],"mappings":"AAEA;EACE,YAAY;EACZ,6BAA6B;;EAE7B,aAAa;EACb,qCAAqC;EACrC,iCAAiC;EACjC,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;;EAE/B,kBAAkB;EAClB,qCAAqC;EACrC,8CAA8C;;EAE9C,uCAAuC;EACvC,wCAAwC,EAAE,QAAQ;EAClD,iDAAiD;EACjD,2CAA2C;;EAE3C,qCAAqC;EACrC,+CAA+C;EAC/C,yCAAyC;;EAEzC,mBAAmB;EACnB,yBAAyB;;EAEzB,WAAW;EACX,mCAAmC;;EAEnC,yCAAyC;EACzC,mCAAmC;;EAEnC,6BAA6B;;EAE7B,wCAAwC;EACxC,kCAAkC;;EAElC,kDAAkD;;EAElD,4DAA4D;;;EAG5D,cAAc;EACd,sCAAsC;EACtC,kCAAkC;;EAElC,gCAAgC;EAChC,gCAAgC;;EAEhC,uCAAuC;;;EAGvC,UAAU;EACV,4CAA4C;EAC5C,sCAAsC;;EAEtC,0CAA0C;EAC1C,oCAAoC;;;EAGpC,SAAS;EACT,wBAAwB;;EAExB,2BAA2B;EAC3B,uCAAuC;EACvC,4BAA4B;EAC5B,mCAAmC;AACrC","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&family=Roboto:wght@400;700&family=Lato:wght@400;700&family=Montserrat:wght@400;700&family=Poppins:wght@400;700&family=Raleway:wght@400;700&family=Source+Sans+Pro:wght@400;700&family=Ubuntu:wght@400;700&family=Nunito:wght@400;700&family=Playfair+Display:wght@400;700&family=Merriweather:wght@400;700&family=Inter:wght@400;700&family=Noto+Sans:wght@400;700&family=Quicksand:wght@400;700&family=Work+Sans:wght@400;700&family=Rubik:wght@400;700&family=Mulish:wght@400;700&family=DM+Sans:wght@400;700&family=Outfit:wght@400;700&family=Josefin+Sans:wght@400;700&family=Crimson+Text:wght@400;700&family=Space+Grotesk:wght@400;700&family=Manrope:wght@400;700&family=Fira+Sans:wght@400;700&family=Karla:wght@400;700&display=swap');\n\n:root {\n  /* General */\n  --qa-backgroundColor: #ffffff;\n\n  /* Question */\n  --qa-questionBackgroundColor: #F7F8FE;\n  --qa-questionBorderColor: #dbe0f7;\n  --qa-questionTextColor: #000000;\n  --qa-questionIconColor: #3D97FC;\n  --qa-questionGlowColor: #3D97FC;\n\n  /* Focus Section */\n  --qa-focusSectionBorderColor: #bdcde4;\n  --qa-focusSectionSeperatorBorderColor: #ececec;\n\n  --qa-focusSectionQuestionFontSize: 16px;\n  --qa-focusSectionQuestionFontWeight: 600; /* NEW */\n  --qa-focusSectionQuestionBackgroundColor: #ffffff;\n  --qa-focusSectionQuestionTextColor: #000000;\n  \n  --qa-focusSectionAnswerFontSize: 14px;\n  --qa-focusSectionAnswerBackgroundColor: #ffffff;\n  --qa-focusSectionAnswerTextColor: #000000;\n\n  /* FeedbackThumbs */\n  --qa-thumbsColor: #3D97FC;\n\n  /* Navbar */\n  --qa-navbarBackgroundColor: #F7F8FE;\n\n  --qa-navbarActiveBackgroundColor: #ffffff;\n  --qa-navbarActiveTextColor: #000000;\n\n  --qa-navbarTextColor: #a2a2a2;\n\n  --qa-navbarHoverBackgroundColor: #ffffff;\n  --qa-navbarHoverTextColor: #000000;\n\n  --qa-navbarKeyWordButtonMobileBorderColor: #818181;\n\n  --qa-navbarKeyWordButtonMobileActiveBackgroundColor: #545454;\n\n\n  /* Chatfield */\n  --qa-chatfieldBackgroundColor: #f9f9f9;\n  --qa-chatfieldBorderColor: #e1e1e1;\n  \n  --qa-chatfieldTextColor: #000000;\n  --qa-chatfieldIconColor: #3D97FC;\n\n  --qa-chatfieldPlaceholderColor: #96a4b3;\n\n\n  /* Extra */\n  --qa-disclaimerPopupBackgroundColor: #F7F8FE;\n  --qa-disclaimerPopupTextColor: #000000;\n\n  --qa-feedbackPopupBackgroundColor: #ffffff;\n  --qa-feedbackPopupTextColor: #000000;\n\n\n  /* Font */\n  --qa-fontFamily: inherit;\n\n  --qa-questionFontSize: 12px;\n  --qa-focusSectionQuestionFontSize: 16px;\n  --qa-chatFieldFontSize: 14px;\n  --qa-navKeywordButtonFontSize: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
